import classNames from 'classnames';
import { autobind } from 'core-decorators';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import SwipeableViews from 'react-swipeable-views';
import { bindActionCreators } from 'redux';
import { _ } from '/@/locale';
import { getSessionCountry } from '/@/store/session/selectors';
import { trackEvent } from '/@/store/tracking/actions';

import ErrorView from '/@/views/error-view';
import styles from './styles.module.css';

@connect(
    () => {
        return (state, props) => ({
            country: getSessionCountry(state),
            weed: props.weed,
            offline: state.network && state.network.offline,
        });
    },
    (dispatch) => bindActionCreators({ trackEvent }, dispatch)
)
@autobind
export default class WeedDetail extends Component {
    static propTypes = {
        weed: PropTypes.object,
    };

    static contextTypes = {
        theme: PropTypes.string,
        history: PropTypes.object,
    };

    state = {
        imageIndex: 0,
        loadedImages: 0,
    };

    createChangeImageIndexHandler(direction) {
        const handleChangeImageIndex = (index) => {
            this.setState({ imageIndex: index });
            this.props.trackEvent({ key: 'weedDetail.changeImage', index });
        };

        if (!direction) return handleChangeImageIndex;

        return () => {
            const maxIndex = this.props.weed.images.length - 1;
            let newIndex = this.state.imageIndex + direction;
            if (newIndex < 0) newIndex = maxIndex;
            if (newIndex > maxIndex) newIndex = 0;
            handleChangeImageIndex(newIndex);
        };
    }

    render() {
        const { weed } = this.props;
        if (!weed) return <ErrorView />;

        return (
            <div className={styles.root}>
                <div className={styles.detail}>
                    {!this.props.offline && (
                        <div className={styles.slider}>
                            <SwipeableViews
                                index={this.state.imageIndex}
                                onChangeIndex={this.createChangeImageIndexHandler()}
                                slideStyle={{ overflow: 'hidden' }}
                                animateHeight={this.state.loadedImages > 0}
                            >
                                {weed.images.map((image) => (
                                    <img
                                        key={image.id}
                                        src={image.file}
                                        className={styles.image}
                                        onLoad={() =>
                                            this.setState((state) => ({
                                                loadedImages: state.loadedImages + 1,
                                            }))
                                        }
                                    />
                                ))}
                            </SwipeableViews>
                            {weed.images.length > 1 && (
                                <div className={styles.controls}>
                                    <div className={styles.prev} onClick={this.createChangeImageIndexHandler(-1)}>
                                        <i className='material-icons'>keyboard_arrow_left</i>
                                    </div>
                                    <div className={styles.next} onClick={this.createChangeImageIndexHandler(1)}>
                                        <i className='material-icons'>keyboard_arrow_right</i>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                    <div className={styles.content}>
                        <div className={styles.header}>
                            <div className={styles.common}>{_(weed.name)}</div>
                        </div>
                        {_(weed.otherNames) && (
                            <div className={styles.row}>
                                <div className={classNames(styles.text, styles[this.context.theme])}>
                                    {_('Otros nombres')}:
                                </div>
                                {_(weed.otherNames)}
                            </div>
                        )}
                        {weed.family && (
                            <div className={styles.row}>
                                <div className={classNames(styles.text, styles[this.context.theme])}>
                                    {_('Familia')}:
                                </div>
                                {_(weed.family)}
                            </div>
                        )}
                        {weed.type && (
                            <div className={styles.row}>
                                <div className={classNames(styles.text, styles[this.context.theme])}>{_('Tipo')}:</div>
                                {_(weed.type)}
                            </div>
                        )}
                        {weed.cycle && (
                            <div className={styles.row}>
                                <div className={classNames(styles.text, styles[this.context.theme])}>{_('Ciclo')}:</div>
                                {_(weed.cycle)}
                            </div>
                        )}
                        {weed.weatherSeasons.length > 0 && (
                            <div className={styles.row}>
                                <div className={classNames(styles.text, styles[this.context.theme])}>
                                    {_('Estación')}:
                                </div>
                                {weed.weatherSeasons.map((ws) => _(ws)).join(', ')}
                            </div>
                        )}
                        {weed.biotypes.length > 0 && (
                            <div className={styles.row}>
                                <div className={classNames(styles.text, styles[this.context.theme])}>
                                    {_('Biotipo')}:
                                </div>
                                {weed.biotypes.map((b) => _(_(b))).join(', ')}
                            </div>
                        )}
                        {_(weed.sizeDescription) && (
                            <div className={styles.row}>
                                <div className={classNames(styles.text, styles[this.context.theme])}>
                                    {_('Tamaño')}:
                                </div>
                                {_(weed.sizeDescription)}
                            </div>
                        )}
                        {_(weed.flowerFruitDescription) && (
                            <div className={styles.row}>
                                <div className={classNames(styles.text, styles[this.context.theme])}>
                                    {_('Fruto / Flores')}:
                                </div>
                                {_(weed.flowerFruitDescription)}
                            </div>
                        )}
                        {_(weed.leavesDescription) && (
                            <div className={styles.row}>
                                <div className={classNames(styles.text, styles[this.context.theme])}>{_('Hojas')}:</div>
                                {_(weed.leavesDescription)}
                            </div>
                        )}
                        {_(weed.rootStemDescription) && (
                            <div className={styles.row}>
                                <div className={classNames(styles.text, styles[this.context.theme])}>
                                    {_('Tallo / Raíces')}:
                                </div>
                                {_(weed.rootStemDescription)}
                            </div>
                        )}
                        {_(weed.reproductionDescription) && (
                            <div className={styles.row}>
                                <div className={classNames(styles.text, styles[this.context.theme])}>
                                    {_('Reproducción')}:
                                </div>
                                {_(weed.reproductionDescription)}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
